import { Injectable } from "@angular/core";

import { combineLatest, Observable } from "rxjs";
import { map } from "rxjs/operators";

import { DffError } from "@dffedb/util";
import { AktuelBrugerObserver } from "@e-forsyning/common/bruger";
import { ILoginoplysninger } from "@e-forsyning/common/loginoplysninger";
import { ValgtInstallationService } from "@e-forsyning/common/valgt-installation";

import { LoginoplysningerFormBuilder } from "./loginoplysninger-form-builder";
import { LoginoplysningerViewModel } from "./model/loginoplysninger.view-model";

@Injectable({ providedIn: "root" })
export class LoginoplysningerSandbox {
    constructor(
        private readonly valgtInstallationService: ValgtInstallationService,
        private readonly aktuelBrugerObserver: AktuelBrugerObserver
    ) {}

    public hentViewModel(): Observable<LoginoplysningerViewModel> {
        const installationsoplysninger$ = this.valgtInstallationService.hentInstallationsoplysninger();
        const rolle$ = this.aktuelBrugerObserver.valueChanges.pipe(map((bruger) => bruger && bruger.rolle));

        return combineLatest([installationsoplysninger$, rolle$]).pipe(
            map(([installationsoplysninger, rolle]) => {
                const formGroup = LoginoplysningerFormBuilder.opretForm(installationsoplysninger);
                return { installationsoplysninger, formGroup, rolle };
            })
        );
    }

    public async redigerLoginoplysninger(loginoplysninger: ILoginoplysninger): Promise<any> {
        try {
            return await this.valgtInstallationService.redigerLoginoplysninger(loginoplysninger);
        } catch (e) {
            throw new DffError(e.message, { friendlyMessage: this.hentVenligtBeskedTilRedigerLoginoplysninger(e), innerError: e });
        }
    }

    public async redigerMail(mail: string): Promise<any> {
        try {
            return await this.valgtInstallationService.redigerMail(mail);
        } catch (e) {
            throw new DffError(e.message, { friendlyMessage: this.hentVenligtBeskedTilRedigerMail(e), innerError: e });
        }
    }

    private hentVenligtBeskedTilRedigerMail(e: any): string {
        let besked = e.message;
        if (e.message.includes("412")) {
            besked = "Mailadressen er allerede i systemet.";
        } else {
            besked = "Fejl i redigering af mailadresse.";
        }
        return besked;
    }

    private hentVenligtBeskedTilRedigerLoginoplysninger(e: any): string {
        let besked: string;
        if (e.message.includes("403")) {
            besked = "Nuværende kodeord er forkert.";
        } else {
            besked = "Fejl i redigering af kodeord.";
        }
        return besked;
    }
}
